import { cn } from "@/lib/utils";

export function ChevronIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-3.5 w-2 text-white", className)}
      viewBox="0 0 8 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 13l6-6-6-6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
